document.addEventListener('DOMContentLoaded', function() {
  const productSlider = document.querySelector('.cards-slider');
  
  if (productSlider) {
    const swiper = new Swiper('.cards-slider', {
      slidesPerView: 3.5,
      spaceBetween: 14,
      observer: true,
      observeParents: true,
      watchSlidesProgress: true,
      freeMode: true,
      grabCursor: true,
      mousewheel: { forceToAxis: true },
      navigation: {
        nextEl: '.cards-slider-nav-btn-next-mob',
        prevEl: '.cards-slider-nav-btn-prev-mob',
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        520: {
          slidesPerView: 1.5,
          spaceBetween: 12,
        },
        650: {
          slidesPerView: 2,
          spaceBetween: 12,
        },
        960: {
          slidesPerView: 2.5,
          spaceBetween: 12,
          navigation: {
            nextEl: '.cards-slider-nav-btn-next',
            prevEl: '.cards-slider-nav-btn-prev',
          }
        },
        1070: {
          slidesPerView: 3,
          spaceBetween: 14,
          navigation: {
            nextEl: '.cards-slider-nav-btn-next',
            prevEl: '.cards-slider-nav-btn-prev',
          }
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 14,
          navigation: {
            nextEl: '.cards-slider-nav-btn-next',
            prevEl: '.cards-slider-nav-btn-prev',
          }
        },
      },
    });
  }
});